import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";
import { ScheduledTime } from "model";

/**
* @class ScheduledAlert
* @classdesc Class definition for record type from model
* @param {OBJECT} record - record from model to init class
* @extends BCMSRecord
* @example const record = model.timezones[0];
* const contactInfo = new ScheduledAlert(record);
* @property {NUMBER} _id - The id of the quietTime.
* @property {BOOLEAN} _isEnabled - The on/off value of the quick time, set by the user.
* @property {ARRAY} _weekdayIDs - An array of weekday ids set by the user.
* @property {ScheduledTime} _scheduledTime - The scheduled time.
*/
export default class ScheduledAlert extends BCMSRecord {
    _id
    _isEnabled
    _weekdayIDs
    _scheduledTime

    constructor (record){     
      super(record) 
    }
  }
  ScheduledAlert.define({
    "recordType":"scheduledAlerts",
    "recordIDProp":"id",
    "className" : "ScheduledAlert",
    "recordProperties":[
      /** 
       * @name id
       * @instance
       * @property get {NUMBER} - gets the id of the ScheduledAlert
       * @property set {NUMBER} - sets the id of the ScheduledAlert
       * @memberof ScheduledAlert
       */
      BCMSRecordProperty.mapToString("id","_id"),

      /** 
       * @name isEnabled
       * @instance
       * @property get {NUMBER} - gets the isEnabled value of the ScheduledAlert
       * @property set {NUMBER} - sets the isEnabled value of the ScheduledAlert
       * @memberof ScheduledAlert
       */
      BCMSRecordProperty.mapToBoolean("isEnabled","_isEnabled"),

      /** 
       * @name scheduledTime
       * @instance
       * @property get {STRING} - gets the value of the scheduledTime
       * @property set {STRING} - sets the value of the scheduledTime
       * @memberof ScheduledAlert
       */
      BCMSRecordProperty.mapToClass("scheduledTime", "_scheduledTime", () => ScheduledTime),

        /**
         * @name weekdayIDs
         * @instance
         * @property get {ARRAY} - gets the weekdayIDs of the scheduled alert
         * @property set {ARRAY} - sets the weekdayIDs of the scheduled alert
         * @note The mapToArray currently does not work correctly when the toRecord function is called
         * @memberof ScheduledAlert
         */
        BCMSRecordProperty.mapTo({
            id: "weekdayIDs",
            instanceField: "_weekdayIDs",
            setter: function(value) {
                this._weekdayIDs = value === undefined || Array.isArray(value)
                    ? value : value.split(",");
            },
            toRecord: function() {
                return this._weekdayIDs === undefined || this._weekdayIDs.length === 0
                    ? ""
                    : this._weekdayIDs.reduce((result, item) => `${ result },${ item }`);
            }
        })
    ]  
})




